import { render, staticRenderFns } from "./BankSlip.vue?vue&type=template&id=32261ed2"
import script from "./BankSlip.vue?vue&type=script&lang=js"
export * from "./BankSlip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports